import { render, staticRenderFns } from "./AwsHuawei.vue?vue&type=template&id=4a4fa1c4"
import script from "./AwsHuawei.vue?vue&type=script&lang=js"
export * from "./AwsHuawei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports